module.exports = "../../../../platform/assets/pageMainIcon/youth_jichudanganlei2.svg";